import React from 'react';
import { observer } from 'mobx-react';

const DelayRender = (props) => {
	if(props.test) {
		return <div>{props.children}</div>
	}

	return null;
}

export default observer(DelayRender);


// WEBPACK FOOTER //
// ./src/app/components/Common/DelayRender.js